import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { SET_RESPONSE_STATUS } from '../../services/cms-page-data.service';
import { TsPieceComponent } from '../shared/ts-piece/ts-piece.component';
import { PROJECTS, Project } from './projects.data';
export type { Project };

/**
 * Ficha de caso (`/a-medida/:slug`) — plantilla única para los 6 casos,
 * servida desde `projects.data.ts` (campo `ficha`): hero con captura ·
 * "Qué necesitaban / Qué montamos" · "Lo que lleva dentro" (piezas) · capturas
 * con pie · resultado · CTA. Slug desconocido → 404 real en SSR.
 */
@Component({
  selector: 'app-proyecto-detalle',
  standalone: true,
  imports: [RouterLink, TsPieceComponent],
  templateUrl: './proyecto-detalle.component.html',
  styleUrl: './proyecto-detalle.component.scss',
})
export class ProyectoDetalleComponent {
  private route = inject(ActivatedRoute);
  private seo = inject(SeoService);
  private setStatus = inject(SET_RESPONSE_STATUS, { optional: true });

  project = signal<Project | null>(null);

  constructor() {
    this.route.paramMap.pipe(takeUntilDestroyed()).subscribe(pm => {
      this.resolve(pm.get('slug') ?? '');
    });
  }

  private resolve(slug: string): void {
    const p = PROJECTS.find(x => x.slug === slug) ?? null;
    if (!p) {
      this.project.set(null);
      this.setStatus?.(404);
      this.seo.update({
        title: 'Caso no encontrado',
        description: 'El caso que buscas no existe o ha cambiado de dirección.',
        path: `/a-medida/${slug}`,
      });
      return;
    }
    this.project.set(p);
    this.seo.update({
      title: p.title,
      description: p.ficha.heroSubtitle.slice(0, 160),
      path: `/a-medida/${p.slug}`,
    });
  }
}
